export default "__VITE_ASSET__00yeVN1s__"